import React from 'react'
import classNames from 'classnames'
import _LeftTopBox from './_LeftTopBox' //左上角：实时报到人数
import _LeftBottomBox from './_LeftBottomBox' //左下角：学院报到
import _CenterTop1 from './_CenterTop1' //中上1：报到人数折线图
import _CenterTop2 from './_CenterTop2' //中上2：报到率饼图
import _CenterTop3 from './_CenterTop3' //中上3：报到总人数
import _Map from './_Map' //中间地图
import _CenterBottomBox1 from './_CenterBottomBox1' //中下1：全校男女生比例
import _CenterBottomBox2 from './_CenterBottomBox2' //中下2：实时之最
import _RightTopBox from './_RightTopBox' //右上角：姓氏排行榜
import _RightBottomBox from './_RightBottomBox' //右下角：
import defaultLogo from './images/logo.png'

import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'

const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const speed = 15 * 1000 //轮询时间间隔（毫秒）
const errMaxCount = 3 // 请求异常最大次数
export default class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      rem: 100,
      errCount: 0, //连续请求错误次数
      schoolData: {}, //学校、迎新年度数据
      mapData: {}, //地图数据
      panelData: {}, //接收子组件报到人数数据源
      errCount1: 0, //连续请求错误次数
    }

    this.polling
    this.polling1
  }

  componentDidMount() {
    // 表示1920的设计图,使用100PX的默认值
    const whdef = 100 / 1920
    // 当前窗口的宽度
    const wW = window.innerWidth
    // 以默认比例值乘以当前窗口宽度,得到该宽度下的相应FONT-SIZE值
    const rem = parseInt(wW * whdef)

    this.setState({ rem })
    document.documentElement.style.fontSize = rem + 'px'

    /** ================== 下面开始请求数据 ================== */
    this.getData() //获取学校、当前迎新年度信息
    this.getBdList() //获取报到信息
  }

  componentWillUnmount() {
    document.documentElement.style.fontSize = null

    if (this.polling) {
      clearTimeout(this.polling)
    }
    if (this.polling1) {
      clearTimeout(this.polling1)
    }
  }

  getData = () => {
    //获取学校、当前迎新年度信息
    NHFetch(yxxtBasicUrl + '/sstj/getUniversityAndCurrentYearInfo', 'GET')
      .then(res => {
        if (res && res.data) {
          this.setState({ errCount: 0, schoolData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          clearTimeout(this.polling)
        }
      })

    //获取地图信息
    NHFetch(yxxtBasicUrl + '/sstj/getMapInfo', 'GET')
      .then(res => {
        if (res && res.data) {
          this.setState({ errCount: 0, mapData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          clearTimeout(this.polling)
        }
      })
  }

  /* 获取报到信息（报到人数/报到率） */
  getBdList = _ => {
    const pkid = sessionStorage.getItem('pkid');
    NHFetch(yxxtBasicUrl + '/sstj/getSchoolReportedSituationByLcid', 'GET',{pkid: pkid})
      .then(res => {
        if (res && res.data) {
          this.polling1 = setTimeout(() => {
            this.getData()
          }, speed)

          this.setState({ errCount: 0, panelData: res.data })
        }
      })
      .catch(err => {
        let { errCount1 } = this.state
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount1 < errMaxCount) {
          this.polling1 = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount1: errCount1 + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling1) {
            clearTimeout(this.polling1)
          }
        }
      })
  }

  render() {
    const { rem, schoolData = {}, mapData = {}, panelData = {} } = this.state
    const pkid = sessionStorage.getItem('pkid');
    let width = 20.2
    if (schoolData && schoolData.xxmc && schoolData.xxmc.length > 9) {
      width += schoolData.xxmc.length - 9 
    }
    return (
      <div className={styles.show_box}>
        <div className={styles.logo} style={{ width: `${width}rem` }}>
          <img
            style={{ maxWidth: 40, maxHeight: 40 }}
            src={
              'api/zhxg-xtgl/schoolMng/downloadSchoolPictureByType?type=logo'
            }
            onError={e => {
              e.target.src = defaultLogo
            }}
          />
          <span className={styles.top_font}>
            {schoolData.xxmc}
            {schoolData.dqnd}年迎新实时数据展示
          </span>
        </div>
        {/* 第一列 */}
        <div className={styles.box_1}>
          <div className={styles.box_bg1}>
            <_LeftTopBox pkid={pkid} rem={rem} />
          </div>
          <div className={styles.box_line} />
          <div className={classNames(styles.box_bg1, styles.box_bg2)}>
            <_LeftBottomBox pkid={pkid} rem={rem} />
          </div>
        </div>
        {/* 第二列 */}
        <div className={styles.box_2}>
          <div className={styles.box_2_top}>
            <_CenterTop1 pkid={pkid} rem={rem} panelData={panelData} />
            <_CenterTop2 pkid={pkid} panelData={panelData} />
            <_CenterTop3 pkid={pkid} panelData={panelData} />
          </div>
          <div className={styles.box_2_middle}>
            <div className={styles.box_2_middle_map}>
              <_Map
                pkid={pkid}
                rem={rem}
                schoolLocation={schoolData.xzqh}
                mapProvince={mapData.province}
              />
              <div className={styles.box_2_middle_bg}></div>
            </div>
          </div>
          <div className={styles.box_line} />
          <div className={styles.box_2_bottom}>
            <_CenterBottomBox1 pkid={pkid} rem={rem} />
            <_CenterBottomBox2 pkid={pkid} rem={rem} />
          </div>
        </div>
        {/* 第三列 */}
        <div className={styles.box_3}>
          <div className={styles.box_bg1}>
            <_RightTopBox pkid={pkid} rem={rem} />
          </div>
          <div className={styles.box_line} />
          <div className={classNames(styles.box_bg1, styles.box_bg2)}>
            <_RightBottomBox pkid={pkid} rem={rem} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./containers/Show-new/index.js